import { call, select, takeLatest } from "redux-saga/effects";
import actionTypes from "../../actions/actionTypes";
import { OVERLAY_KEY_MULTISITE_SELECTOR, OVERLAY_SPINNER } from "../../constants/overlayTypes";
import { MULTISITE_SELECTOR_EDITED, MULTISITE_SELECTOR_ITEMS, MULTISITE_SELECTOR_ORDER } from "../../constants/state";
import getData from "../../functions/getData";
import { overlaySetOverlay, putError,  putSuccess} from "../helpers"
import { updateMultisiteSelector } from "./helpers";

const selectData = state => ({
    edited: getData(state, MULTISITE_SELECTOR_EDITED),
    items: getData(state, MULTISITE_SELECTOR_ITEMS).toJS(),
    order: getData(state, MULTISITE_SELECTOR_ORDER).toJS(),
})


function* updateData() {
    try {
        yield call(overlaySetOverlay, OVERLAY_KEY_MULTISITE_SELECTOR, OVERLAY_SPINNER)

        const data =  yield select(selectData)
        const response = yield call(updateMultisiteSelector, data)

        yield putSuccess(actionTypes.MULTISITE_SELECTOR_UPDATE_SUCCESS, response.data, OVERLAY_KEY_MULTISITE_SELECTOR)
    } catch(e) {
        console.log('ERROR', e)
        yield putError(actionTypes.MULTISITE_SELECTOR_UPDATE_ERROR, e.message, OVERLAY_KEY_MULTISITE_SELECTOR)
    }

}

function* watchMultisiteSelectorUpdateRequest() {
    yield takeLatest(actionTypes.MULTISITE_SELECTOR_UPDATE_REQUEST, updateData);

}

export default watchMultisiteSelectorUpdateRequest